import React from 'react'
import { assignContentTypeId, fileType } from '../../../utils/contentful'
import { useEntity } from '../selectors'
import sw from '../../../utils/switch'
import EVComponent from './ev-component'

export const EVEntry = (props) => {
  const rawEntity = useEntity(props)

  if (rawEntity.err || !rawEntity) {
    return null
  }

  const entity = sw({
    'image/svg+xml': assignContentTypeId('imageModule'),
    'image/jpeg': assignContentTypeId('imageModule'),
    default: (i) => i,
  })(fileType(rawEntity), rawEntity)

  return <EVComponent {...props} {...entity} />
}
